// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs[data-v-7bba5e9a]{font-size:.875rem;line-height:1.25rem}.toc-link[data-v-7bba5e9a]{transition:color .3s ease,text-shadow .3s ease}.toc-link.is-active[data-v-7bba5e9a],.toc-link[data-v-7bba5e9a]:hover{text-shadow:#000 1px 0 0}@media(max-width:1024px){aside div[data-v-7bba5e9a]{position:static!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
